// extracted by mini-css-extract-plugin
module.exports = {"add-currency":"no_currency_alert__add-currency___29uOV"};